import React, { PureComponent } from 'react';

import { getCurrentUserEvents } from '../api/users-api';

export default class SocketEventsRestorer extends PureComponent {
    async restore(from, offset = 0, limit = 100) {
        if (!this.props.teamToken) {
            return Promise.resolve();
        }

        const response = await getCurrentUserEvents({ from, offset, limit });

        if (response) {
            this.props.onEvents(response.events);

            if (response.hasMore) {
                return this.restore(from, offset + limit, limit);
            }
        }

        return new Promise(resolve => {
            setTimeout(resolve, 1000);
        });
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            restore: from => {
                this.restore(from);
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        return null
    }
};
